const CONSENT_KEY = "futuredoc_ai_data_processing_consent_v1";
const CHANGE_EVENT = "fd-ai-consent-change";

export function getAIDataProcessingConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return { granted: false };
    const parsed = JSON.parse(raw);
    if (typeof parsed?.granted !== "boolean") return { granted: false };
    return parsed;
  } catch {
    return { granted: false };
  }
}

export function setAIDataProcessingConsent(granted) {
  const now = Date.now();
  const next = granted ? { granted: true, grantedAt: now } : { granted: false, revokedAt: now };
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(next));
  } catch {
    /* storage unavailable */
  }
  window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: next }));
  return next;
}

export function hasAIDataProcessingConsent() {
  return getAIDataProcessingConsent().granted === true;
}

export function subscribeAIDataProcessingConsent(listener) {
  const handler = () => listener(getAIDataProcessingConsent());
  window.addEventListener(CHANGE_EVENT, handler);
  window.addEventListener("storage", handler);
  return () => {
    window.removeEventListener(CHANGE_EVENT, handler);
    window.removeEventListener("storage", handler);
  };
}
